import React, {useRef} from "react";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import {v4} from "uuid";
import FormControl from "@mui/material/FormControl";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import charcreate from "../../_helper/charcreate";
import {ICharThread} from "../../_interfaces/iCharThread";
import {s_char, s_char_threadsteps} from "../../_signals/s_char";
import {ICharThreadStep} from "../../_interfaces/iCharThreadStep";
import {ThreadStepCreate} from "../../_api/BEThreads";
import {ICharLPChanges} from "../../_interfaces/ICharLPChanges";
import updChar from "../../_sig_api/updChar";
import {LPChangesCreate} from "../../_api/BELPChanges";
import {useSignals} from "@preact/signals-react/runtime";
import {s_app_sl} from "../../_signals/s_app";

interface IProp {
    open: ICharThread | null,
    isOpen: (open: boolean) => void
}

export default function ThreadStepAdd({open, isOpen}: IProp) {
    useSignals()

    const nameRef = useRef<HTMLInputElement>(null);
    const descRef = useRef<HTMLInputElement>(null);

    const savestep = () => {
        if (!open) return
        let threadsteps = s_char_threadsteps.value;

        const num = threadsteps
            .filter(ts => ts.tid === open.id)
            .map(ts => ts.num)
            .reduce((prev, current) => prev < current ? current : prev, 0)

        const add: ICharThreadStep = {
            id: v4(),
            cid: s_char.value.id,
            tid: open.id,
            num: num + 1,
            name: nameRef.current?.value ?? '',
            descr: descRef.current?.value ?? '',
        }


        const cost = charcreate.raiseCost(open.lpstart, add.num-1);

        let lp_current = s_char.value["lp_current"];
        const nsc = s_char.value["nsc"];

        const no_lp = nsc && s_app_sl.value;

        if (nsc && !s_app_sl.value) return;

        let canadd=false;
        if (no_lp) {
            canadd = true;
        } else if (cost > 0) {

            if (cost < lp_current) {
                if (window.confirm('Steigerung ' + open.name + ' auf Rang ' + add.num + ' Kosten ' + cost)) {
                                       canadd = true;
                }
            } else alert('zu wenig lp');
        } else alert('lp kosten fehler');


        if(canadd) {
            lp_current = lp_current - cost;

            updChar([{k:'lp_current',v:lp_current}])

            const time = new Date().toISOString();
            const lpchanges:ICharLPChanges={cid: s_char.value.id, id: v4(), ts: time, entry:'-' + cost + ' Faden ' + open.name + ' auf Rang ' + add.num}
            LPChangesCreate(lpchanges)

            threadsteps.push(add)
            s_char_threadsteps.value = threadsteps
            ThreadStepCreate(add)

            isOpen(false)
        }
    }


    return <Dialog open={!!open}>
        <DialogContent>
            <FormControl sx={{m: 1, width: "100%"}}>
                <TextField
                    defaultValue={''}
                    inputRef={nameRef}
                    label="step name"
                />
            </FormControl>
            <FormControl sx={{m: 1, width: "100%"}}>
                <TextField
                    defaultValue={''}
                    inputRef={descRef}
                    label="step desc"
                />
            </FormControl>
        </DialogContent>
        <DialogActions>
            <Button onClick={() => savestep()}><CheckIcon/></Button>
            <Button onClick={() => isOpen(false)}><ClearIcon/></Button>
        </DialogActions>
    </Dialog>

}

